import React, { Component } from 'react';
import { connect, } from 'react-redux';
import { Container, Spinner, Row } from 'react-bootstrap';
import { withRouter } from '../withRouter';
import { Howl, Howler } from "howler";
import { createRoom, reconnectToRoom, } from 'actions/room';
import * as Sentry from "@sentry/react";

import GameList from "constants/GameList";
import AuthService from 'services/auth';

import styles from './LobbyStyles.module.scss';
import formStyles from "components/Forms/FormStyles.module.scss";
import DotLoader from 'components/Utlility/DotLoader';

import Game from "components/Games/Game";
import GameMenu from "./GameMenu";
import FormPage from '../Forms/FormPage';
import BuyForLobbyModal from 'components/BuyForLobbyModal/BuyForLobbyModal';

import lobbyBgMusic from "audio/lobby-bg-music.mp3";
import joinedSFX from "audio/player-joined.wav";
import disconnectingSFX from "audio/disconnecting.wav";
import disconnectedSFX from "audio/disconnected.wav";
import hoverOrClickSFX from "audio/hover-click.mp3";
import newGameSFX from "audio/new-game.wav";
import errorSFX from "audio/error.wav";
import ErrorModal from '../Utlility/ErrorModal';
import { RoomErrorCodes } from 'constants/ErrorCodes';

import muteButton from "images/icons/lobby_unmuted.png"
import mutedButton from "images/icons/lobby_muted.png"
import fullscreenButton from "images/icons/lobby_fullscreen.png"
import { APP_TYPES } from 'constants/AppTypes';
import { postCapabilitiesOncePerDevice } from "telemetry/capabilitiesPostOnce.ts";

const fullscreenAvailable = document.fullscreenEnabled || document.mozFullscreenEnabled || document.webkitFullscreenEnabled ? true : false;
var unBindPlayerJoindMessage = null;
var unBindPlayerLeaveMessage = null;
var unBindRefreshLobbyGamesMessage = null;

var audio = {
    lobbyBg: {
        import: lobbyBgMusic,
        loaded: null,
        volume: 0.15,
        loop: true,
    },
    joined: {
        import: joinedSFX,
        loaded: null,
        volume: 1,
        loop: false,
    },
    disconnecting: {
        import: disconnectingSFX,
        loaded: null,
        volume: 1,
        loop: false,
    },
    disconnected: {
        import: disconnectedSFX,
        loaded: null,
        volume: 1,
        loop: false,
    },
    hoverOrClick: {
        import: hoverOrClickSFX,
        loaded: null,
        volume: 0.35,
        loop: false,
    },
    newGame: {
        import: newGameSFX,
        loaded: null,
        volume: 1,
        loop: false,
    },
    error: {
        import: errorSFX,
        loaded: null,
        volume: 1,
        loop: false,
    }
};

class Lobby extends Component {
    static displayName = Lobby.name;

    constructor(props) {
        super(props);

        this.state = {
            connected: false,
            userGames: [],
            userAddons: [],
            freeGames: [],
            loadingGames: true,
            roomError: false,
            errorMessage: "",
            selectedGame: null,
            notifications: [],
            roomLoadingTitle: "",
            acceptedScreenSizeWarning: false,
            muted: false,
        };
    }


    componentDidMount() {
        const queryParams = new URLSearchParams(window.location.search);
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
        if (this.props.room.roomOpen && !this.props.room.isHost) {
            if (queryParams.has("roku")) {
                return setTimeout(() => this.props.navigate(`/play?roku`));
            } else {
                return setTimeout(() => this.props.navigate(`/play`));
            }
        }

        if (this.props.auth.isLoggedIn) { // user logged in?
            if (this.props.room.roomOpen === false) { // room already open?
                if (queryParams.has("token")) { // is attempting reconnect?
                    // reconnect here
                    this.doReconnect(queryParams.get("token"));
                } else {
                    console.log("Creating Room...");
                    const QRSessionID = queryParams.get("QRSessionID");
                    console.log("QRsession: " + QRSessionID);
                    this.doCreate(QRSessionID);
                }
            } else {
                if (this.props.room.isHost) { // are they the host?
                    this.setState({ notifications: [] });
                    this.getUserGames();
                    this.initAudio();
                    this.updateToken(this.props.room.room.reconnectionToken);
                    this.setTags();
                    this.setRoomListeners();
                } else {
                    return setTimeout(() => this.props.navigate("/join"));
                }
            }
        }
    }

    componentWillUnmount() {
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        Howler.stop();
    }

    handleVisibilityChange = () => {
        if (document.hidden && Howler) {
            Howler.mute(true);
        } else if (!document.hidden && Howler) {
            Howler.mute(this.state.muted);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.room.roomOpen === true && prevProps.room.roomOpen === false) {
            this.setRoomListeners();
        } else if (this.props.room.roomOpen === false && prevProps.room.roomOpen === true) {
            if (this.props.room.startingGame !== true) {
                this.playAudio(audio.error.loaded);
                Howler.stop();
                this.setState({ roomError: true, errorMessage: "The room closed unexpectedly, please click below to try again.", });
            }
        }

        if (this.props.room.startingGame === true && prevProps.room.startingGame === false) {
            this.playAudio(audio.newGame.loaded);
        }
    }

    componentWillUnmount() {
        Howler.stop();
        this.removeRoomListeners();
    }

    initAudio() {
        this.preloadAudio();
        Howler.volume(0.5);
        console.log("!!!!!!!!!!!!!")
        // Only play if not already playing
        if (audio.lobbyBg.loaded && !audio.lobbyBg.loaded.playing()) {
            this.playAudio(audio.lobbyBg.loaded, true, 0.05);
        }
    }

    preloadAudio() {
        for (let key in audio) {
            if (audio[key].loaded) continue;
            audio[key].loaded = new Howl({
                src: [audio[key].import],
                preload: true,
                loop: audio[key].loop,
                volume: audio[key].volume
            });
        }
    }

    playAudio(audio) {
        if (audio) audio.play();
    }

    toggleFullScreen = () => {
        if (fullscreenAvailable) {
            if (!document.fullscreenElement && !document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
                let elem = document.documentElement
                if (elem.requestFullscreen) {
                    elem.requestFullscreen();
                } else if (elem.webkitRequestFullscreen) {
                    elem.webkitRequestFullscreen();
                } else if (elem.mozRequestFullScreen) {
                    elem.mozRequestFullScreen();
                } else if (elem.msRequestFullscreen) {
                    elem.msRequestFullscreen();
                }
            } else {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen();
                } else if (document.mozExitFullscreen) {
                    document.mozExitFullscreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            }
        }
    }

    doCreate(QRSessionID = null) {
        this.setState({ roomError: false, errorMessage: "", roomLoadingTitle: "Creating your room", })
        console.log("Calling create room with session: " + QRSessionID)
        this.props.createRoom(this.props.auth.user.token, this.props.auth.user.id, false, QRSessionID).then((res) => {
            if (res.Status === "Error") {
                Howler.stop();
                this.setState({ roomError: true, errorMessage: res.Message, });
                Sentry.captureMessage(`Error creating room: ${res.Message}`);
            } else if (res.Status === "Success") {
                this.setState({ notifications: [] });
                this.getUserGames();
                this.initAudio();
            }
        });
    }

    doReconnect(token) {
        this.setState({ roomError: false, errorMessage: "", roomLoadingTitle: "Reconnecting to your room", })
        setTimeout(() => {
            this.props.reconnectToRoom(token).then((res) => {
                if (res.Status === "Error") {
                    Howler.stop();
                    this.setState({ roomError: true, errorMessage: res.Message, });
                } else if (res.Status === "Success") {
                    this.setState({ notifications: [] });
                    this.getUserGames();
                    this.initAudio();
                }
            });
        }, 1500);

    }

    getUserGames() {
        this.setState({ loadingGames: true });
        AuthService.getGames(this.props.auth.user.email).then((response) => {
            console.log("Response from getGames: ", response);
            this.setState({ userGames: response.games, loadingGames: false, userAddons: response.addons, freeGames: response.freeGames }, () => {
                console.log("Updated state:", this.state);
            });
            let gameIds = response.games.map(x => x.code);
            let addonsIds = response.addons.map(x => x.code);
            let freeGameIds = response.freeGames.map(x => x.code);
            let availableGames = [...new Set([...gameIds, ...freeGameIds])];
            this.props.room.room.send("update_available_games", { games: availableGames, addons: addonsIds, });
            this.props.room.room.send("update_pin", { pin: response.roomPin });
        }).catch((err) => {
            console.log("Error getting user games: ", err);
        });
    }

    setRoomListeners() {
        this.updateToken(this.props.room.room.reconnectionToken);
        this.setTags();
        postCapabilitiesOncePerDevice();

        if (unBindPlayerJoindMessage) unBindPlayerJoindMessage()
        unBindPlayerJoindMessage = this.props.room.room.onMessage("player_joined", (message) => {
            console.log("player_joined", "received on", this.props.room.room.name, message);
            this.playAudio(audio.joined.loaded);
            this.doNotification(`${message.player.name} has joined!`);
        });

        if (unBindPlayerLeaveMessage) unBindPlayerLeaveMessage()
        unBindPlayerLeaveMessage = this.props.room.room.onMessage("player_leave", (message) => {
            console.log("player_leave", "received on", this.props.room.room.name, message);
            this.playAudio(audio.disconnected.loaded);
            this.doNotification(`${message.player.name} has left!`);
        });

        if (unBindRefreshLobbyGamesMessage) unBindRefreshLobbyGamesMessage()
        unBindRefreshLobbyGamesMessage = this.props.room.room.onMessage("refresh_lobby_games", (message) => {
            console.log("refresh_lobby_games", "received on", this.props.room.room.name);
            this.getUserGames();
        });

    }

    removeRoomListeners() {
        if (unBindPlayerJoindMessage) unBindPlayerJoindMessage()
        if (unBindPlayerLeaveMessage) unBindPlayerLeaveMessage()
        if (unBindRefreshLobbyGamesMessage) unBindRefreshLobbyGamesMessage()
    }

    doNotification(text) {
        this.setState((prevState) => {
            return { notifications: [...prevState.notifications, text] }
        });
        setTimeout(() => {
            this.setState((prevState) => {
                prevState.notifications.shift();
                return { notifications: prevState.notifications }
            });
        }, 5000);
    }

    getOwnedGames() {
        let userGames = [...this.state.userGames];
        let ownedGameList = [];
        let freeGames = [...this.state.freeGames];
        let freeGameList = [];

        GameList.forEach((x) => {
            if (userGames.findIndex((y) => y.code === x.gameId) > -1) {
                ownedGameList.push(x);
            } else if (freeGames.findIndex((y) => y.code === x.gameId) > -1) {
                freeGameList.push(x);
            }
        });

        return <ul className={styles.games}>
            {ownedGameList.map(g => {
                const gameVotes = this.props.room.players.filter((player) => player.gameVote === g.gameId).length;
                return <li className={styles.game} key={g.gameId}>
                    <Game game={g} fromLobby={true} loadGameMenu={this.loadGameMenu} gameVotes={gameVotes} addons={this.state.userAddons} supported={true} />
                </li>
            })}
            {freeGameList.map(g => {
                const gameVotes = this.props.room.players.filter((player) => player.gameVote === g.gameId).length;
                return <li className={styles.game}>
                    <Game game={g} key={g.gameId} fromLobby={true} loadGameMenu={this.loadGameMenu} gameVotes={gameVotes} addons={this.state.userAddons} supported={true} />
                </li>
            })}
        </ul>
    }

    isDev() { return !process.env.REACT_APP_ENVIRONMENT || process.env.REACT_APP_ENVIRONMENT === 'development' }

    getUnownedGames() {
        let userGames = [...this.state.userGames];
        let freeGames = [...this.state.freeGames];
        let unownedGameList = [];

        GameList.filter(g => g.enabled || this.isDev()).forEach((x) => {
            if ([...userGames, ...freeGames].findIndex((y) => y.code === x.gameId) <= -1) {
                unownedGameList.push(x);
            }
        });

        return <ul className={styles.games}>
            {unownedGameList.map(g => <li className={styles.game} key={g.gameId}><Game game={g} showAddToCart={true} showBuyNow={true} smallCartButton={true} onBuyNow={this.onBuyGameForLobby} /></li>)}
        </ul>;
    }

    hasAllGames() {
        let userGames = [...this.state.userGames];
        let freeGames = [...this.state.freeGames];

        let ownedGameList = [];
        GameList.forEach((x) => {
            if (userGames.findIndex((y) => y.code === x.gameId) > -1) {
                ownedGameList.push(x);
            } else if (freeGames.findIndex((y) => y.code === x.gameId) > -1) {
                ownedGameList.push(x);
            }
        });

        if (ownedGameList.length === GameList.length) {
            return true;
        } else {
            return false;
        }
    }

    loadGameMenu = (game) => {
        console.log("Clicked game : ", game);
        this.playAudio(audio.hoverOrClick.loaded);
        this.setState({ selectedGame: game });
    }

    closeGameMenu = () => {
        this.playAudio(audio.hoverOrClick.loaded);
        this.setState({ selectedGame: null });
    }

    closeAndLeave = () => {
        if (this.props.room.roomOpen) {
            this.props.room.room.leave(true);
        }
        this.playAudio(audio.hoverOrClick.loaded);
        this.props.navigate("/");
    }

    acceptSmallScreen = () => {
        this.playAudio(audio.hoverOrClick.loaded);
        this.setState({ acceptedScreenSizeWarning: true });
    }

    updateToken(token) {
        var url = new URL(window.location.href);

        try {
            window.history.replaceState(null, null, (url.pathname) + (`?token=${token}`));
        } catch (e) {
            console.warn(e)
        }
    }


    setTags() {
        const queryParams = new URLSearchParams(window.location.search);

        const token = queryParams.get("token");
        Sentry.setTag('isHost', true);

        if (token) {
            const [roomId, reconnectToken] = token.split(':');
            Sentry.setTag('roomId', roomId);
            Sentry.setTag('reconnectToken', reconnectToken);
        }
    }

    mute = () => {
        this.setState({ muted: !this.state.muted });
        Howler.mute(!this.state.muted);
    }

    getUserFriendlyRoomError = () => {
        let error = RoomErrorCodes[this.props.room.errorCode];
        console.log("error code:", this.props.room.errorCode);
        if (!error) error = RoomErrorCodes.default;
        return error.displayMessage;
    }

    refreshGames = () => {
        this.setState({ refreshingGames: true, refreshCooldown: 10 });
        this.props.room.room.send("refresh_lobby_games", {});

        const cooldown = setInterval(() => {
            const cooldownTime = this.state.refreshCooldown - 1;
            this.setState({ refreshCooldown: cooldownTime });
            if (cooldownTime === 0) {
                this.setState({ refreshingGames: false });
                clearInterval(cooldown);
            }
        }, 1000);
    }

    onPurchased = () => {
        this.setState({ BuyForLobbyGame: null });
        this.refreshGames();
    }

    onBuyGameForLobby = (game) => {
        this.setState({ BuyForLobbyGame: game });
    }

    render() {
        return (
            <React.Fragment>
                <div className={`${styles.gameLobbyBackground} d-none d-md-block`}>
                    <div className={styles.settingButtons}>
                        {fullscreenAvailable && <button className={styles.muteButton} onClick={this.toggleFullScreen} >
                            <img src={fullscreenButton} alt="fullscreen-button" />
                        </button>}
                        <button className={styles.muteButton} onClick={this.mute} >
                            <img src={this.state.muted ? mutedButton : muteButton} alt="mute-button" />
                        </button>
                    </div>
                    <div className={styles.gameLobby}>
                        {
                            this.props.room.roomOpen ?
                                <React.Fragment>
                                    <div className={styles.notificationsContainer}>
                                        {
                                            this.state.notifications.map((notification) => {
                                                return <div className={styles.notification}>{notification}</div>
                                            })
                                        }
                                    </div>

                                    {
                                        this.state.loadingGames ?
                                            <div className={styles.loadingBox}>
                                                <h2>Loading your games</h2>
                                                <DotLoader size="large" variant="light" />
                                            </div>
                                            :
                                            <Container fluid>
                                                {
                                                    (this.state.userGames.length === 0 && this.state.freeGames.length) === 0 ?
                                                        <Row className="text-center justify-content-center text-white">
                                                            <h3 className="mb-0">Looks like you don’t have any games yet!</h3>
                                                            <h5 className="mb-5"><strong>You can buy your first game below…</strong></h5>
                                                            

                                                            <h4 className="mt-4 mb-0">Think you should have some games?</h4>
                                                            <h6 className="mb-1"><strong>Click below to refresh!</strong></h6>
                                                            <button
                                                                className={`${styles.button} ${styles.small}`}
                                                                style={{ width: "fit-content" }}
                                                                onClick={() => window.location.reload()}
                                                            >
                                                                Refresh Page
                                                            </button>

                                                            <h4 className="mt-4 mb-0">Still having issues?</h4>
                                                            <h6 className="mb-0"><strong>Check you're logged into the correct account.</strong></h6>
                                                            <h6><strong>If you are, get in touch at: <a style={{ color: "white" }} href="mailto:info@thegamescollective.com">info@thegamescollective.com</a></strong></h6>
                                                        </Row>
                                                        :
                                                        <>
                                                            <h2 className={`text-center ${styles.lobbyTitle}`}>Select A Game</h2>
                                                            {this.getOwnedGames()}
                                                        </>
                                                }

                                                {
                                                    !this.hasAllGames() &&
                                                    <h2 className={styles.separator}>Add More</h2>
                                                }
                                                {
                                                    this.getUnownedGames()
                                                }
                                            </Container>
                                    }
                                </React.Fragment>
                                :
                                this.state.roomError ?
                                    <div className={styles.pageProblem} >
                                        {/*<h2>{this.state.errorMessage}</h2>*/}
                                        <h2>{this.getUserFriendlyRoomError()} <br /> Click below to rejoin the fun!</h2>
                                        <button className={styles.button} onClick={() => this.doCreate()}>Retry</button>
                                    </div>
                                    :
                                    <div className={styles.loadingBox}>
                                        <h2>{this.state.roomLoadingTitle}</h2>
                                        <DotLoader size="large" variant="light" />
                                    </div>
                        }

                    </div>

                </div>
                {!this.state.acceptedScreenSizeWarning && <ErrorModal
                    title={"Screen Size Warning"}
                    styles={`${styles.screenModel} d-flex`}
                    message={"Your screen looks too small to host Game City... Please try hosting on a larger screen, like a tablet, TV or laptop and ensure it has an aspect ratio of 4:3 or wider. If you still wish to continue you will likely encounter visual issues!"}
                    callback={this.closeAndLeave}
                    callbackText={"Back"}
                    callback2={this.acceptSmallScreen}
                    callbackText2={"Continue"}
                />}
                {/*<div className={`${styles.screenOverlay} d-flex d-sm-flex d-md-none`} >*/}
                {/*    <div className={styles.screenOverlayBG}></div>*/}
                {/*    <FormPage modal={true}>*/}
                {/*        <h2 className={formStyles.formTitle}>Screen Size Warning</h2>*/}
                {/*        <p>Your screen looks too small to host Game City... Please try hosting on a larger screen, like a tablet, TV or laptop.</p>*/}
                {/*        <button onClick={() => this.closeAndLeave()} className={`${styles.button} ${styles.alternate}`}>Back</button>*/}
                {/*    </FormPage>*/}
                {/*</div>*/}

                {
                    this.state.selectedGame &&
                    <GameMenu game={this.state.selectedGame} closeGameMenu={this.closeGameMenu} supported={true} />
                }
                {this.state.BuyForLobbyGame &&
                    <BuyForLobbyModal
                        game={this.state.BuyForLobbyGame}
                        hostUser={this.props.auth.user}
                        onPurchased={this.onPurchased}
                        onClose={() => { this.setState({ BuyForLobbyGame: null }); }}
                    />
                }
            </React.Fragment>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        room: state.room,
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        createRoom: (token, userId, isRoku, QRSessionID) => {
            return dispatch(createRoom(token, userId, APP_TYPES.WEB, isRoku, QRSessionID))
        },
        reconnectToRoom: (token) => {
            return dispatch(reconnectToRoom(token))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Lobby));
